import Language from '@/constants/Language';
import { StyledLanguageSelector } from './LanguageSelector.styled';
import useLanguageSelector from './useLanguageSelector.hook';

export default function LanguageSelector({ className = '', small }) {
  const { state, actions } = useLanguageSelector();
  return state.showSelector ? (
    <StyledLanguageSelector className={`${small ? 'small' : ''} ${className}`}>
      <div
        className={`option ${state.selectedLanguage == 'es' ? 'active' : ''}`}
        onClick={() => actions.setSelectedLanguage('es')}
      >
        <span className="text">Spanish</span>
        <span className="flag">{Language.labels.es}</span>
      </div>
      <div
        className={`option ${state.selectedLanguage == 'fr' ? 'active' : ''}`}
        onClick={() => actions.setSelectedLanguage('fr')}
      >
        <span className="text">French</span>
        <span className="flag">{Language.labels.fr}</span>
      </div>
    </StyledLanguageSelector>
  ) : null;
}
